<script lang="ts">
	import WebGeneralLayout from "./WebGeneralLayout.svelte";
	
	import DdLib from "@ludans/dashboard-dyslexia";

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const hashInUrl = urlParams.get("hash");

	let hash: string = hashInUrl || DdLib.randomHash();

</script>

<WebGeneralLayout {hash}/>
